import { render, staticRenderFns } from "./SmallTicketListItem.vue?vue&type=template&id=69c6ebe8"
import script from "./SmallTicketListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallTicketListItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports